import {
  APP_SKU_HEADER,
  X_WELLFRAME_HOSPITAL_ID,
  X_WF_CLIENT_APPLICATION,
  X_WF_CLIENT_APPLICATION_VALUE,
} from 'store/constants';
import { RootState } from '../store/store';

/**
 * Prepares API headers based on the current application state.
 *
 * @param headers - The headers object to modify
 * @param state - The Redux store state
 * @returns The modified headers object
 */
export const prepareApiHeaders = (headers: Headers, state: RootState): Headers => {
  headers.set(X_WF_CLIENT_APPLICATION, X_WF_CLIENT_APPLICATION_VALUE);
  // Set authorization header if access token exists
  if (state.auth.accessToken) {
    headers.set('Authorization', `Bearer ${state.auth.accessToken}`);
  }

  if (state.cobrand.clientCobrand) {
    headers.set(APP_SKU_HEADER, state.cobrand.clientCobrand.sku);
  }

  if (state.auth.user?.hospital?.id) {
    headers.set(X_WELLFRAME_HOSPITAL_ID, `${state.auth.user.hospital.id}`);
  }

  return headers;
};
